import { linkToClassPage } from "../../links";

export function linkToClassSettingsPage(classId?: string) {
  return `${linkToClassPage(classId)}/settings`;
}
